module.exports = {"Type":"Login","Disabled":true,"Fields":[{"label":"Variabili da valorizzare","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"brown","Text":"LOGIN"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Login.json
// module id = 698
// module chunks = 0